import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  billDeactivateOptionsMigrate: {
    id: 'mac.licenses.cancel.modal.deactivate',
    defaultMessage: 'We are moving to another cloud platform',
    description: 'Options migrate text',
  },
  billDeactivateReasonsCancellingSubscriptionAsk: {
    id: 'mac.licenses.cancel.modal.deactivate.reasons-cancelling-subscription.ask',
    defaultMessage: 'Please tell us more about your reasons for cancelling your subscription.',
    description: 'Reasons cancelling subscription ask text',
  },
  billDeactivateSubscriptionReasonsNewSolutionAsk: {
    id: 'mac.licenses.cancel.modal.deactivate.reasons-new-solution.ask',
    defaultMessage: 'Please tell us more about which solution you are moving to and why.',
    description: 'Reasons new solution ask text',
  },
  billDeactivateCovidAsk: {
    id: 'mac.licenses.cancel.modal.deactivate.covid.ask.deactivate',
    defaultMessage:
      'Please tell us more about how the coronavirus outbreak has affected your organization financially.',
    description: 'Reasons covid text',
  },
  billDeactivateOptionsClosed: {
    id: 'mac.licenses.cancel.modal.deactivate.options.closed',
    defaultMessage: 'My organization has closed down',
    description: 'Reasons closed organization text',
  },
  billDeactivateOptionsProjectBased: {
    id: 'mac.licenses.cancel.modal.deactivate.options.project-based',
    defaultMessage:
      'We needed the solution for a single project or other temporary work which has since ended',
    description: 'Reasons project based text',
  },
  billDeactivateOptionsNotMeetingNeeds: {
    id: 'mac.licenses.cancel.modal.deactivate.options.not-meeting-needs',
    defaultMessage: "This solution no longer meets our organization's needs",
    description: 'Reasons not meeting needs text',
  },
  billDeactivateOptionsCost: {
    id: 'mac.licenses.cancel.modal.deactivate.options.cost',
    defaultMessage: "The pricing or licensing didn't meet our needs",
    description: 'Reasons cost text',
  },
  billDeactivateOptionsMovingToServerDC: {
    id: 'mac.licenses.cancel.modal.deactivate.options.moving-to-server-or-dc',
    defaultMessage: 'We are moving to an Atlassian Server or Data Center solution',
    description: 'Reasons moving to server/DC text',
  },
  billDeactivateOptionsMerging: {
    id: 'mac.licenses.cancel.modal.deactivate.options',
    defaultMessage: 'We are merging or using another Atlassian Cloud instance',
    description: 'Reasons merging text',
  },
  billDeactivateOptionsPostEvaluation: {
    id: 'mac.licenses.cancel.modal.deactivate.options.post-evaluation',
    defaultMessage: 'We were still evaluating the product but have decided to deactivate it',
    description: 'Reasons post evaluation text',
  },
  billDeactivateOptionsSandbox: {
    id: 'mac.licenses.cancel.modal.deactivate.options.sandbox',
    defaultMessage: 'We used this instance for testing/as a sandbox',
    description: 'Reasons sandbox text',
  },
  billDeactivateOptionsResetting: {
    id: 'mac.licenses.cancel.modal.deactivate.options.resetting',
    defaultMessage: 'We are resetting/starting fresh with this instance',
    description: 'Reasons resetting text',
  },
  billDeactivateOptionsCompetitorPlural: {
    id: 'mac.licenses.cancel.modal.deactivate.options.competitor-plural',
    defaultMessage: 'We are moving to a different solution',
    description: 'Reasons competitor plural text',
  },
  billDeactivateOptionsCovid: {
    id: 'mac.licenses.cancel.modal.deactivate.options.covid',
    defaultMessage:
      'We have been financially affected by the coronavirus outbreak and need to reduce costs',
    description: 'Reasons covid text',
  },
  billDeactivateOptionsOther: {
    id: 'mac.licenses.cancel.modal.deactivate.options.other',
    defaultMessage: 'Other',
    description: 'Reasons other text',
  },
  submitSurveyButton: {
    id: 'mac.licenses.cancel.modal.survey.submit',
    defaultMessage: 'Next',
  },
  subscriptionCancelled: {
    id: 'mac.licenses.cancel.modal.survey.cancelled.subscription',
    defaultMessage: 'Subscription successfully cancelled',
  },
  subscriptionTakeCareMessage: {
    id: 'mac.licenses.cancel.modal.survey.take.care.message',
    defaultMessage: 'We take understanding why our customers cancel their subscriptions seriously.',
  },
  cancelingReasonQuestion: {
    id: 'mac.licenses.cancel.modal.survey.cancel.reason.question',
    defaultMessage:
      'Can you tell us which of the following best describes your main reason for cancelling this cloud product or site?',
  },
  selectOneMessage: {
    id: 'mac.licenses.cancel.modal.survey.select.reason',
    defaultMessage: 'Select only one',
  },
  permanentlyCancelSite: {
    id: 'mac.licenses.cancel.modal.confirm.button',
    defaultMessage: 'Yes, permanently cancel my site',
  },
  doNotCancelSite: {
    id: 'mac.licenses.cancel.modal.reject.button',
    defaultMessage: "No, don't cancel my site",
  },
  cancelCloudSiteCTA: {
    id: 'mac.licenses.cancel.modal.title',
    defaultMessage: 'Cancel your cloud site',
  },
  typeToContinue: {
    id: 'mac.licenses.cancel.modal.confirm.cancelling',
    defaultMessage: 'To continue please type CANCEL below',
  },
  learnAboutCancelling: {
    id: 'mac.licenses.cancel.modal.canceling.subscriptions.info',
    defaultMessage: 'Learn more about canceling site subscriptions.',
  },
  siteAccessInfo: {
    id: 'mac.licenses.cancel.modal.site.access.info',
    defaultMessage: 'You will still be able to access your site until its expiration on ',
  },
  externallyManagedProducts: {
    id: 'mac.licenses.cancel.modal.externally.managed.products',
    defaultMessage:
      'The following externally managed products are due to renew after your site is cancelled: ',
  },
  contactMessage: {
    id: 'mac.licenses.cancel.modal.contact.message',
    defaultMessage: 'Contact us',
  },
  financialDifficulties: {
    id: 'mac.licenses.cancel.modal.financial.difficulties',
    defaultMessage:
      'Are you facing financial difficulties? We’re here to help. Get in touch now to discuss your situation.',
  },
  cancelProductsModal: {
    id: 'mac.licenses.cancel.modal.cancelling.products.message',
    defaultMessage: 'This will delete your site: {cloudSite} and remove these products: ',
  },
  licensesCancelSiteModalMessage: {
    id: 'mac.licenses.cancel.modal.cancelling.site.message',
    defaultMessage:
      'Cancelling your Cloud site: {cloudSite} and remove these products: will permanently remove it from your account.',
  },
  licensesCancelSiteModalConfirmation: {
    id: 'mac.licenses.cancel.modal.confirmation.text',
    defaultMessage: 'Are you sure you want to cancel {siteUrl} ?',
  },
});
